import { render, staticRenderFns } from "./TicTacToe.vue?vue&type=template&id=f2112400&"
import script from "./TicTacToe.vue?vue&type=script&lang=js&"
export * from "./TicTacToe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports